<template>
  <div class="trainingList" id="training-list">
    <SOSlotBase :container-name="`trainingList`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Kampus Smartlink'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div class="bg p-y-12 d-flex" v-if="riwayatTraining.length > 0">
          <div class="d-block">
            <div class="f-semi f-14">
              Mohon unduh terlebih dahulu aplikasi zoom pada perangkat anda
              sebelum meeting
            </div>
          </div>
        </div>

        <template>
          <MyTraining :something="0"></MyTraining>
        </template>
        <div class="bar p-x-20 remove-margin trainingJenis">
          <template v-for="jenisTraining in dataListTraining">
            <CardJenisTraining
              :namaTraining="jenisTraining.nama"
              :id-jenis="jenisTraining.id"
              :harga="jenisTraining.harga"
              :card-detail="jenisTraining.keterangan"
              :data="jenisTraining"
              :key="jenisTraining.id"
            />
          </template>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";
import CardJenisTraining from "../components/CardJenisTraining";
import MyTraining from "../components/MyTraining";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "Training-List",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
    CardJenisTraining,
    MyTraining,
  },
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      dataListTraining: "dataJenisTraining",
      riwayatTraining: "riwayatTraining",
    }),
  },

  data() {
    return {
      isLoading: false,
      // dataTraining: [],
    };
  },
  methods: {
    ...mapActions({
      getListJenisTraining: `${moduleName}/getListJenisTraining`,
      getRiwayatTraining: `${moduleName}/getRiwayatTraining`,
    }),
    async init() {
      await this.getListJenisTraining();
      await this.getRiwayatTraining("belum_selesai");
      // await this.dataDisableTraining();
    },
    back() {
      this.$router.go(-1);
    },

    // dataDisableTraining() {
    //   for (let i = 0; i < this.riwayatTraining.length; i++) {
    //     if (this.dataTraining.length == 0) {
    //       this.dataTraining.push(this.riwayatTraining[i].training_jenis_id);
    //     }
    //     if (this.riwayatTraining[i].training_jenis_id != this.dataTraining[0]) {
    //       this.dataTraining.push(this.riwayatTraining[i].training_jenis_id);
    //     }
    //     if (this.riwayatTraining[i].training_jenis_id != this.dataTraining[1]) {
    //       this.dataTraining.push(this.riwayatTraining[i].training_jenis_id);
    //     }
    //     if (this.riwayatTraining[i].training_jenis_id != this.dataTraining[3]) {
    //       this.dataTraining.push(this.riwayatTraining[i].training_jenis_id);
    //     }
    //   }
    //   console.log(this.dataTraining);
    // },
  },
};
</script>

<style scoped>
.trainingList .separator {
  width: unset;
  height: 15px;
}

.bar {
  margin-top: auto;
  margin-bottom: auto;
}
</style>
